<template>
  <v-row style="margin-right: 15px">
    <v-col
      cols="12"
      sm="12"
      md="12"
      v-for="dateRange in dateRanges"
      :key="dateRange.text"
    >
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="dates"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dateRangeText"
            prepend-icon="mdi-calendar"
            :placeholder="dateRange.text"
            readonly
            v-bind="attrs"
            v-on="on"
            clearable
            @click:clear="resetDates"
          ></v-text-field>
        </template>
        <v-date-picker range v-model="dates" no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="resetDates()">
            Cancel
          </v-btn>
          <v-btn text color="primary" @click="saveDates(dates)">
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import {
  CLEAR_DATE_RANGE_VALUE,
  SET_DATE_RANGE_VALUE
} from "../../../core/services/store/dateranges.module";

export default {
  data: () => ({
    dates: [],
    menu: false
  }),
  methods: {
    saveDates(dates) {
      this.$refs.menu[0].save(dates);
      if (dates[0] <= dates[1]) {
        this.$store.dispatch(SET_DATE_RANGE_VALUE, [
          { startDate: dates[0], endDate: dates[1] }
        ]);
      } else {
        this.$store.dispatch(SET_DATE_RANGE_VALUE, [
          { startDate: dates[1], endDate: dates[0] }
        ]);
      }
    },

    swapDates(dates) {
      const temp = dates[0];
      dates[0] = dates[1];
      dates[1] = temp;
      return dates;
    },

    resetDates() {
      this.dates = [];
      this.$store.dispatch(CLEAR_DATE_RANGE_VALUE);
      this.menu = false;
    }
  },
  computed: {
    ...mapGetters(["dateRanges"]),
    ...mapGetters(["dateRangesValue"]),
    dateRangeText() {
      if (this.dates[0] > this.dates[1]) {
        this.swapDates(this.dates);
      }
      return this.dates.length > 0 ? this.dates.join(" ~ ") : "";
    }
  }
};
</script>

<style></style>
